import { render, staticRenderFns } from "./applications-table-row.vue?vue&type=template&id=152d168c"
import script from "./applications-table-row.vue?vue&type=script&lang=js"
export * from "./applications-table-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports